/*
 * Bennie UI Header
 */

import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import profile from '@benniehealth/core-js/store/profile';
import { Bars3Icon } from '@heroicons/react/24/solid';

import IconButton from '@mui/material/IconButton';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Icon from '@mui/material/Icon';
import SvgIcon from '@mui/material/SvgIcon';

import BennieWhiteLogoSvg from '@app/images/svg/logo_bennie_white.svg';

const PREFIX = 'index';

const classes = {
  appBar: `${PREFIX}-appBar`,
  toolbar: `${PREFIX}-toolbar`,
  headerLogo: `${PREFIX}-headerLogo`,
  iconButton: `${PREFIX}-iconButton`,
  menuIcon: `${PREFIX}-menuIcon`,
  logoLink: `${PREFIX}-logoLink`,
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.appBar}`]: {
    backgroundColor: theme.palette.primary.main,
    zIndex: 200,
  },
  [`& .${classes.toolbar}`]: {
    padding: '0 0 0 16px',
    minHeight: '56px',
  },
  [`& .${classes.headerLogo}`]: {
    width: `auto`,
    height: `20px`,
    paddingLeft: '12px',
    '&.MuiSvgIcon-root': {
      width: `auto`,
      height: `20px`,
    },
  },
  [`& .${classes.iconButton}`]: {
    padding: '0',
  },
  [`& .${classes.menuIcon}`]: {
    color: 'white',
  },
  [`& .${classes.logoLink}`]: {
    display: `flex`,
  },
}));

const Header = ({ onToggleMenu }) => {
  const { authState } = useOktaAuth();

  if (!authState?.isAuthenticated) {
    return null;
  }

  return (
    <Root className={classes.root}>
      <AppBar
        position="fixed"
        color="default"
        elevation={0}
        className={classes.appBar}
      >
        <Toolbar className={classes.toolbar}>
          <IconButton
            onClick={_event => onToggleMenu()}
            className={classes.iconButton}
            size="large"
            color="primary"
          >
            <Icon className={classes.menuIcon} component={Bars3Icon} />
          </IconButton>

          <Link to="/" className={classes.logoLink}>
            <SvgIcon
              className={classes.headerLogo}
              component={BennieWhiteLogoSvg}
              title="Go to Home Page"
              viewBox="0 0 360 114"
            />
          </Link>
        </Toolbar>
      </AppBar>
    </Root>
  );
};

Header.propTypes = {
  onToggleMenu: PropTypes.func,
};

const mapStateToProps = state => {
  return {
    companyName: profile.selectors.getCompanyName(state),
    accessToCompany: profile.selectors.getRoleType(state),
    error: profile.selectors.profileErrorSelector(state),
  };
};

export default connect(mapStateToProps)(Header);
